module.exports = __webpack_public_path__ + "img/grid-alt-reverse.7a90a263.svg";